


















































































































































import {Constants} from '@/constants';
import {
    AccountTypeEnum,
    PartyCareProviderModel,
    PartyContactModel,
    PartyModel,
    PartyPrintModel,
    PartyPrintTypeEnum, TenantModel,
    TenantUserModel,
    WorkTaskStatementModel
} from '@/libs/Api';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';
import {Guid} from '@/libs/common/functions/guid';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {workTaskStatementsStore} from '@/libs/work-task-statements/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import {partiesStore} from '../+state/store';
import CareProvidersList from '../components/CareProvidersList.vue';
import ImportantContactsList from '../components/ImportantContactsList.vue';
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";
import {tenantsStore} from "@/libs/tenants/+state/store";

@Component({
    components: {
        CareProvidersList, ImportantContactsList
    }
})
export default class General extends Page {

    @Prop() tenantId!: string;
    @Prop() partyId!: string;
    districtId: string | null = null;
    partyCareProviders: PartyCareProviderModel[] = [];
    importantContacts: PartyContactModel[] | null | undefined = [];
    party: PartyModel | null = null;
    basicRules = [
        (v: any) => !!v || this.translate('validation.thisFieldIsRequired')
    ];
    deleteDialogLoading = false;
    deleteDialog = false;
    deleteDialogStatementsExists = false;
    deleting = false;
    valid = false;
	printing = false;

    @Ref() partyCareProviderList!: CareProvidersList;
    @Ref() form!: any;

    get saving(): boolean {
        return partiesStore.useGetter(CrudGetter.Saving);
    }

    get loading(): boolean {
        return partiesStore.useGetter(CrudGetter.Pending);
    }

    get readonly (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        const tenant = tenantsStore.useGetter(CrudGetter.Detail, this.tenantId) as TenantModel;
        if (tenantUser.accountType == AccountTypeEnum.Volunteer) {
            return true;
        }
        else if (tenantUser.accountType == AccountTypeEnum.Worker) {
            if (tenant.enableEditClientByWorker && this.party?.mainCareProviderId == tenantUser.userId) {
                return false;
            }
            else if (tenant.enableEditClientOfAnotherWorkers && this.party?.districtId == tenantUser.mainDistrictId) {
                return false;
            }
            else {
                return true;
            }
        }
        return false;
    }

    mounted () {
        this.party = partiesStore.useGetter(CrudGetter.Detail) as PartyModel;
        if (this.party != null) {
            this.districtId = this.party.districtId!;
            this.partyCareProviders = this.party.partyCareProviders!;
            this.importantContacts = this.party.partyContacts;
            // if (this.partyCareProviders.length == 0) {
            //     this.partyCareProviders.push({
            //         id: Guid.EmptyGuid(),
            //         userId: Guid.EmptyGuid(),
            //         canProvideChargedTasks: true,
            //         freeCareProviders: false,
            //         partyId: this.partyId
            //     } as PartyCareProviderModel);
            // }
        }
        else {
            this.partyCareProviders = [];
        }
    }

    save () {
        this.party!.partyCareProviders = this.partyCareProviderList.getProvidersList();
        this.party!.partyContacts = this.importantContacts;
    }

    deletePartyClick () {
        this.deleteDialogLoading = true;
        workTaskStatementsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskStatementModel>(undefined, [
            { field: "workTask.partyWorkDay.partyId", op: "eq", comparand: this.partyId! }
        ], { pageIndex: 1, pageSize: 1 }, false, "WorkTaskRuleDeleteCheck"));
        this.subscribe(workTaskStatementsStore, CrudReponse.GetAll, "WorkTaskRuleDeleteCheck").then((e: WorkTaskStatementModel[]) => {
            this.deleteDialogLoading = false;
            if (e.length > 0) {
                this.deleteDialogStatementsExists = true;
            }
            else {
                this.deleteDialog = true;
            }
        }).catch((e) => {
            console.error(e);
            this.deleteDialogLoading = false;
            this.deleteDialog = false;
        });
    }

    deleteParty () {
        this.deleting = true;
        partiesStore.dispatch(CrudAction.Delete, { id: this.partyId });
        this.subscribe(partiesStore, CrudReponse.Delete).then((e: any) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.$router.push({ name: "Parties", params: { tenantId: this.tenantId } });
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

	printClick(): void {
		this.printing = true;
		const printModel = {
			printType: PartyPrintTypeEnum.General
		} as PartyPrintModel;
		ApiService.api.printParty(this.partyId, printModel).then((x: any) => {
			this.printing = false;
			const res = x.data;
			const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.setAttribute('download', res.returnValue.filename!);
			document.body.appendChild(link);
			link.click();
			link.parentNode!.removeChild(link);
		}).catch(() => {
			this.printing = false;
		});
	}

	clientStateChanged(to: string, from: string) {
		if (from == to) {
			return;
		}
		if (to != Constants.PartyStateArchivedId) {
			this.party!.endDate = null;
		}
		if (to == Constants.PartyStateInterestedId) {
			this.party!.activatedOn = null;
			this.party!.archivedOn = null;
		}
		else if (to == Constants.PartyStateActiveId) {
			this.party!.activatedOn = moment().format("yyyy-MM-DDTHH:mm:ss");
			this.party!.archivedOn = null;
		}
		else if (to == Constants.PartyStateArchivedId) {
			this.party!.archivedOn = moment().format("yyyy-MM-DDTHH:mm:ss");
			if (this.party!.endDate == null || moment(this.party?.endDate).startOf("day").isAfter(moment().startOf("day"))) {
				this.party!.endDate = moment().add(1, "day").format("yyyy-MM-DDT00:00:00");
			}
		}
	}

}
